import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { applyOpenGraphThumbnailSize, classNames } from '@shapeable/utils';
import { Page, Person, Topic } from '@shapeable/gesda-types';
import { EntityPublicationCard, EntityPublicationCardDefaultProps, EntityPublicationCardProps } from './entity-publication-card';
import { useCurrentEditionMembers } from '../../hooks/use-current-edition-members';
import { useCurrentEditionChairs } from '../../hooks/use-current-edition-chairs';
const cls = classNames('topic-publication-card');

// -------- Types -------->

// -------- Props -------->

export type TopicPublicationCardProps = Omit<EntityPublicationCardProps, 'entity'> & { 
  entity?: Topic;
};

export const TopicPublicationCardDefaultProps: Omit<TopicPublicationCardProps, 'entity'> = {
  ...EntityPublicationCardDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    // quick-fix for chevron color, until button is moved to color token system
    ${theme.FILL('dark')};
  `,
});

const CommitteeStyles = css`
  font-weight: 300;
  font-size: ${14/14}em;
  line-height: 1.30em;
  color: ${theme.COLOR('text-subtle')};
  padding-top: ${theme.UNIT(5)};
`;

const CommitteeChairsStyles = css`
  display: block;
`;

const CommitteeMembersStyles = css`
  display: block;
`;

// -------- Components -------->

const My = {
  Container: styled(EntityPublicationCard)<ContainerProps>`${ContainerStyles}`,
    Committee: styled.div`${CommitteeStyles}`,
      CommitteeChairs: styled.span`${CommitteeChairsStyles}`,
      CommitteeMembers: styled.span`${CommitteeMembersStyles}`,

};

export const TopicPublicationCard: Shapeable.FC<TopicPublicationCardProps> = (props) => {
  const { className, entity, ...cardProps } = props;

  const { committeeMembers = [], committeeChairs = [] } = entity;

  const currentCommitteeMembers = useCurrentEditionMembers(committeeMembers, entity);
  const currentEditionChairs = useCurrentEditionChairs(committeeChairs, entity);

  const transformedEntity: Person = applyOpenGraphThumbnailSize('bubbleLarge')(props.entity);

  const chairNames = currentEditionChairs.map((chair) => chair.name).join(', ');
  const chairsLabel = chairNames ? `${chairNames} (Committee Chair)` : '';

  const visibleMembers = currentCommitteeMembers.slice(0, 3);
  const memberNames = visibleMembers.map((member) => member.name).join(', ');
  const remainingMemberCount = currentCommitteeMembers.length - visibleMembers.length;
  const membersLabel = memberNames
    ? remainingMemberCount > 0
      ? `${memberNames}, +${remainingMemberCount} (Committee)`
      : `${memberNames} (Committee)`
    : '';

  return (
    <My.Container 
      {...cardProps} 
      entity={transformedEntity}
      foot={
        <My.Committee>
          {chairsLabel && (
            <My.CommitteeChairs>{chairsLabel}</My.CommitteeChairs>
          )}
          {membersLabel && (
            <My.CommitteeMembers>{membersLabel}</My.CommitteeMembers>
          )}
        </My.Committee>
      }
      />
  )
};

TopicPublicationCard.defaultProps = TopicPublicationCardDefaultProps;
TopicPublicationCard.cls = cls;